class FormPagination {

    /**
     * @param {jQuery} $context
     */
    constructor($context) {
        this.onButtonClick = [];

        $context.on('click', '.pagination a.page-link', $.proxy(this._triggerButtonClick, this));
    }

    _triggerButtonClick(e) {
        e.preventDefault();

        const pageValue = $(e.target).closest('a').data('value');

        $('[name=page]').val(pageValue);

        this.onButtonClick.forEach((callback) => {
            callback.call(this);
        });
    }

    addOnButtonClick(callback) {
        this.onButtonClick.push(callback);

        return this;
    }
}
